import React, { useState, useEffect } from 'react';
import { Navbar, NavbarGroup, NavbarHeading, NavbarDivider, Spinner, Button } from '@blueprintjs/core';
import Single from './Article'
import API from '../Utilities/API'
import OneArticle from './OneArticle'
import U from '../Utilities/Utilities'
import DateRangeFilter from './DateRangeFilter'
import { Drawer, Position, Classes } from '@blueprintjs/core';
import Cases from '../Cases/Cases';
import CaseSelect from '../Cases/SelectAdd'

export default (props) => {

    const newTimeout = 20; //Seconds to check for new news

    const [search, setSearch] = useState(false);
    const [news, setNews] = useState([]);
    const [loaded, setLoaded] = useState(false);
    const [newCount, setNewCount] = useState(0);
    const [latest, setLatest] = useState('');
    const [loading, setLoading] = useState(false);
    const [moreLoad, setMoreLoad] = useState(false);

    const [pages, setPages] = useState(0);
    const limit = 50;

    const [activeArticle, setActiveArticle] = useState(false)

    const [range, setRange] = useState([null, null]);

    const [showDrawer, setShowDrawer] = useState(false);
    const [drawerCase, setDrawerCase] = useState(null);

    const [selected, setSelected] = useState([]);
    const [selectedUpdate, setSelectedUpdate] = useState(1);

    const onCheck = (group, state) => {
        let newSelected = selected;
        if (state === true) {
            newSelected.push(group);
        } else {
            newSelected = selected.filter((s) => (s.group && s.group.id != group.group.id));
        }
        setSelected(newSelected);
        setSelectedUpdate(new Date().getTime());
    }

    const checkChecked = (group) => {
        return selected.filter((s) => (s.group.id === group.group.id)).length > 0;
    }

    const splitLocation = window.location.href.split('/');
    const last = splitLocation.pop();
    const page = splitLocation.pop();

    let id = props.searchID || '';
    if (id.length === 0 && page === 'intelligence') id = last;

    let checkInterval = 0;

    useEffect(() => {
        clearInterval(checkInterval);
        setNews([]);
        setLoaded(false);
        setPages(0);
        API.SavedSearch(id).then((response) => {
            setSearch(response.data.Data.search);
            API.Intelligence(id, response.data.Data.search.query, null, range, pages * limit).then((r) => {
                setNews(r.data.Data.hits);
                setLoaded(true);
                setLatest(r.data.Data.hits[0]._source.timestamp);
            })
        })
    }, [range]);

    useEffect(() => {
        if (latest.length > 0 && range[0] === null && range[1] === null) {
            clearInterval(checkInterval);
            checkInterval = setInterval(() => {
                API.SavedSearchNew(id, latest).then((response) => {
                    if (response.data.Data.number != newCount) setNewCount(response.data.Data.number);
                })
            }, newTimeout * 1000);
        }
        return () => {
            clearInterval(checkInterval);
        }
    }, [latest, range])

    useEffect(() => {
        if (news.length) {
            API.Intelligence(id, search.query, news.pop()._source.timestamp, range, pages * limit).then((r) => {
                setNews([...news, ...r.data.Data.hits]);
                setMoreLoad(false);
            })
        }
    }, [pages])

    const renderNews = () => {
        let date = '';
        return (
            <>
                {newCount > 0 ? (
                    <Button large fill loading={loading} style={{ background: '#1F4B99' }} onClick={() => {
                        setLoading(true);
                        API.Intelligence(id, search.query).then((r) => {
                            let newList = [];
                            let newNews = r.data.Data.hits.forEach((hit) => {
                                if (hit._source.timestamp > latest) {
                                    newList.push({
                                        ...hit,
                                        isNew: true
                                    });
                                }
                            });
                            news.forEach((article) => {
                                newList.push({
                                    ...article,
                                    isNew: false
                                })
                            })
                            setNews(newList);
                            setLatest(newList[0]._source.timestamp);
                            setLoading(false);
                            setNewCount(0);
                        })
                    }}>
                        There are <strong>{newCount}</strong> new articles. Click here to show.
                    </Button>
                ) : null}
                {news.map((n) => {
                    let cDate = U.date(n._source.timestamp);
                    let showDate = false;
                    if (cDate != date) {
                        date = cDate;
                        showDate = true;
                    }
                    return (
                        <>
                            {showDate ? (<Button
                                fill
                                minimal
                                disabled
                                large
                                icon={'calendar'}
                                style={{ color: '#FFB366', cursor: 'default', position: 'sticky', top: 0, backgroundColor: '#30404d', zIndex: 1 }}
                            >{date}</Button>) : null}
                            <Single
                                {...props}
                                article={n}
                                onClick={() => {
                                    if (activeArticle._id === n._id) setActiveArticle(false);
                                    else setActiveArticle(n);
                                }}
                                active={activeArticle._source && activeArticle._id == n._id}
                                onCheck={onCheck}
                                checkChecked={checkChecked}
                            />
                        </>
                    );
                })}
                <div style={{ padding: 10 }}>
                    <Button large fill loading={moreLoad} onClick={() => {
                        setMoreLoad(true);
                        setPages(pages + 1);
                    }}>Load more</Button>
                </div>
            </>
        )
    }

    return (
        <>
            <Navbar style={{ position: 'sticky', top: 0, paddingLeft: 0 }}>
                <NavbarGroup>
                    <NavbarHeading>Saved Search</NavbarHeading>
                    {!!search ? (
                        <>
                            <NavbarDivider />
                            <NavbarHeading>{search.title}</NavbarHeading>
                            <NavbarDivider />
                            <NavbarGroup>
                                <DateRangeFilter
                                    onChange={(range) => {
                                        setRange(range);
                                    }}
                                />
                            </NavbarGroup>
                            <NavbarDivider />
                            <NavbarGroup>
                                <CaseSelect selectedCase={props.caseID} forceCase={props.forceCase} key={`CaseSelect-${selectedUpdate}`} articles={selected.map((g) => (g.group.id))} onSelect={(casedata) => {
                                    selected.forEach((g) => {
                                        const id = g.group.id;
                                        if (window['reloadCaseTitle' + id]) window['reloadCaseTitle' + id]();
                                    })
                                    if (!props.caseID) {
                                        if (window.confirm('Open case?')) {
                                            setDrawerCase(casedata);
                                            setShowDrawer(true);
                                        }
                                    } else {
                                        props.onSelect && props.onSelect();
                                    }
                                }} />
                            </NavbarGroup>
                        </>
                    ) : null}
                </NavbarGroup>
            </Navbar>
            <div style={{ display: 'block', width: '100%', height: 'calc(100% - 50px)', overflow: 'hidden' }}>
                <div style={{
                    width: (activeArticle._source ? '30%' : '100%'),
                    height: '100%',
                    overflow: 'auto',
                    float: 'left'
                }}>
                    {loaded ? renderNews() : <div style={{ marginTop: 50 }}><Spinner /></div>}
                </div>
                {activeArticle._source ? (
                    <div style={{
                        width: '70%',
                        height: '100%',
                        overflow: 'hidden'
                    }}>
                        <OneArticle
                            key={`OneArticleSavedSearch-${activeArticle._id}`}
                            article={activeArticle}
                        />
                    </div>
                ) : null}
            </div>
            {showDrawer && (
                <Drawer
                    icon={'box'}
                    title={drawerCase.title}
                    autoFocus
                    canEscapeKeyClose={false}
                    canOutsideClickClose={false}
                    enforceFocus
                    hasBackdrop
                    position={Position.RIGHT}
                    size={'100%'}
                    isOpen={true}
                    className={Classes.DARK}
                    onClose={() => {
                        setDrawerCase(null);
                        setShowDrawer(false);
                    }}
                >
                    <Cases
                        popup
                        case={drawerCase}
                        key={drawerCase.id}
                        setCaseText={(text) => {

                        }}
                        reloadCases={() => {

                        }}
                        onCloseCase={() => {
                            setDrawerCase(null);
                            setShowDrawer(false);
                        }}
                    />
                </Drawer>
            )}
        </>
    )

}